var _circle, _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgArrow2 = function SvgArrow2(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    transform: "rotate(90 24 24)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1771 32.2928C23.2321 32.6922 23.5795 33 23.9999 33C24.4585 33 24.8302 32.6337 24.8302 32.1818L24.8302 17.8001L30.0813 22.9953L30.1743 23.0747C30.4989 23.313 30.9602 23.2876 31.2556 22.9977C31.5805 22.6788 31.5816 22.1608 31.258 21.8406L24.5996 15.2523C24.5614 15.213 24.5194 15.1776 24.474 15.1464C24.1498 14.9234 23.6999 14.9548 23.4111 15.2407L16.7419 21.8407L16.6617 21.9326C16.4213 22.2534 16.449 22.7079 16.7445 22.9977C17.0694 23.3166 17.5951 23.3155 17.9187 22.9953L23.1696 17.7988L23.1696 32.1818L23.1771 32.2928Z",
    fill: "#383838"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrow2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow2.b0033ee9.svg";
export { ForwardRef as ReactComponent };